<template>
  <div class="flex space-x-2">
    <lf-badge
      v-if="model.offers_count"
      class="w-min whitespace-nowrap space-x-1"
    >
      <span>{{ $t("DEALS.DEAL_PROGRESS.OFFER_DETAILS") }}</span>
      <span
        class="space-x-1 rounded-full border-0-5 border-gray-300 bg-gray-200 p-0.5 px-1.5 pt-[3px] text-xs leading-none"
      >
        {{ model.offers_count }}
      </span>
    </lf-badge>

    <button-create-offer
      v-if="canCreateOffers && !model.declinePending"
      :model
    />
  </div>
</template>
<script setup lang="ts">
import { Ability, PermissionSubject } from "@/enums/auth";
import { usePermissions } from "@/hooks/auth";
import { useDeals } from "@/hooks/deals";

import LfBadge from "@/components/ui/LfBadge.vue";
import ButtonCreateOffer from "@/views/deals/components/ButtonCreateOffer.vue";

import type { ILenderPlacement } from "@/models/funders";
import type { PropType } from "vue";

defineProps({
  model: {
    type: Object as PropType<ILenderPlacement & { product_type: string }>,
    required: true,
  },
});

const { canPerformActionReactive } = usePermissions();

const { activeDeal } = useDeals();

const canCreateOffers = canPerformActionReactive(
  PermissionSubject.offer,
  Ability.create,
  { application: activeDeal.value?.id }
);
</script>
